import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Row, Col } from 'react-bootstrap';

import genericPorBanner from '../../assets/img/generic_brand_banner.png';
import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor';

import { getInactivePorDeals, getPorDeals } from '../../actions/por-deals';
import { loadPageContent } from '../../actions/content';
import InactivePorCarousel from '../common/home/carousels/inactive-por-carousel';

import './styles.css';
import '../por-deals/styles.css';


class PorPage extends Component {
  constructor(props) {
    super(props);
    this.pageSlug = 'por-page';
  }

  componentWillMount = () => {
    const { dispatch } = this.props;
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
    dispatch(getInactivePorDeals());
    dispatch(getPorDeals());
  }

  render() {
    const { porDeals, contents } = this.props;
    const { pageSlug } = this;

    const porBrands = Array.from(new Set(porDeals.filter(deal => deal.attributes.brand.id)
      .map(deal => ({id: deal.attributes.brand.id, name: deal.attributes.brand.name, por_image: deal.attributes['por-image']}))
      .map(JSON.stringify))).map(JSON.parse);

    return (
      <div className="por-deals">
        <Grid bsClass="container" className="user-inner-container">
          <Row>
            <Col className="por-deals-title" lg={12}>
              <PageTitle>POR DEALS</PageTitle>
            </Col>
          </Row>
          <Row>
            <Col className="por-deals-editable-content" lg={12}>
              <InlineCKEditor
                contents={contents[`${pageSlug}_content_text`]}
                identifier={`${pageSlug}_content_text`}
                onContentSaved={this.handleContentSaved}
              />
            </Col>
          </Row>
        </Grid>
        <div className="container user-inner-container">
          <h1><span className="por-page-red-text" >LIVE!</span> POR deals</h1>
          {porBrands.map(brand => (
            <div key={brand.id} className="por-page-brand-banner">
              <a href={`/por-deals?brand_id=${brand.id}`} className="overlay">
                <div className="por-deal">POR DEAL</div>
                <h4 className="por-deal-brand-name">{brand.name}</h4>
                <div><Button className="red-btn">Check it out</Button>
                </div>
              </a>
              <img src={brand.por_image} />
            </div>
          ))}
          {porDeals.some(deal => deal.attributes.product.id !== null) && (
            <div className="por-page-brand-banner">
              <a href={'/por-deals?is_product=true'} className="overlay">
                <div className="por-deal">POR DEAL</div>
                <h4 className="por-deal-brand-name">More deals</h4>
                <div><Button className="red-btn">Check it out</Button>
                </div>
              </a>
              <img src={genericPorBanner} />
            </div>
          )}
          <div><InactivePorCarousel /></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  contents: state.content.list,
  porDeals: state.porDeals.data,
  inactivePorDeals: state.inactivePorDeals.data,
});

export default connect(mapStateToProps)(PorPage);



// WEBPACK FOOTER //
// ./src/components/por-page/index.jsx